module.exports = __webpack_public_path__ + "static/img/blo3.8be587d0.png";